import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import Help_hints from "../../wepcg/sidebar/help_hints";
import "../../wepcg/sidebar/css/wepcg_bar.css"

class OtherBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>Return Request (Other)</strong></h1>
            <p>
                This claim type is used for return requests other than physical damage. Please include as much background as possible. Lenovo has no return policy and each potential return needs to be validated, approved and authorized. If you claim e.g. order cancellation please attach the original cancellation request sent to Lenovo employee; if there is duplicate order please let us know the number of the duplicated invoice. Make sure the collection details are correct. Contact person should be aware of the incident so our logistics provider can contact them and arrange details of the actual collection. Please have the goods ready for collection. Please contact our financial claims team in case there is any question or problem. Be informed you will be contacted by the returns logistics provider team and they will arrange the exact details of goods collection.
            </p>
            <Help_hints />
        </div>
    }
}

export default OtherBar;